module.exports = __webpack_public_path__ + "static/q11-6b7f0290381e82531675789f738b7c3d.png";